import { forwardRef } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from '@tanstack/react-router';
import { listItemButtonClasses } from '@mui/material';

const activeProps = () => ({ className: listItemButtonClasses.selected });

export const LinkBehavior = forwardRef<
  HTMLAnchorElement,
  Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>(function LinkBehavior({ href, ...other }, ref) {
  // TODO: add support for typed routes
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <RouterLink ref={ref} to={href as any} activeProps={activeProps} {...other} />;
});
